import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';

import { Mode } from 'core/slices/session';
import { IStateReducer } from 'core/reducers/state';
import { IQueue } from 'core/slices/queue';

const queue = (state: RootState) => state.queue;
const state = (state: RootState) => state.state;
const mode = (state: RootState) => state.session.mode;

export const selectFeed = createSelector([queue, mode, state], parseFeed);

export function parseFeed(queue: IQueue, mode: Mode, state: IStateReducer) {
  return queue.progressItems[`${state[EntityTypes.COURSE_PROGRESS]}`] || [];
}
